import { render, staticRenderFns } from "./TwoFaDialog.vue?vue&type=template&id=324a769e"
import script from "./TwoFaDialog.vue?vue&type=script&lang=js"
export * from "./TwoFaDialog.vue?vue&type=script&lang=js"
import style0 from "./TwoFaDialog.vue?vue&type=style&index=0&id=324a769e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports